import React from 'react';

// Design System Components
import Checkbox from 'Components/DesignSystem/Checkbox/Checkbox';

// Module Components
import SectionHeading from './SectionHeading';

// Constants
import { STRINGS } from '../../../constants';

interface PricingSectionProps {
  /** Per element since 14021 — see the note below. */
  showUom: boolean;
  onShowUomChange: (showUom: boolean) => void;
}

/**
 * The Pricing section: one checkbox, "Show unit of measure (UOM)".
 *
 * **Per element since 2026-09-18 (14021), superseding R69.** It used to write one
 * card-wide flag: ticking it under List Price appended the unit to *every* price and
 * showed as ticked in the other three panels. Operators read that as a bug — a panel
 * headed "List Price" changing Sale Price — so the flag moved onto the field's own
 * configuration, and the "Show UOM on prices" pseudo-field that set the same thing
 * from the rail was removed.
 *
 * Like every section here it still takes no field id: the value arrives as a prop and
 * the caller knows which element is inspected (ADR-4B).
 */
const PricingSection = ({ showUom, onShowUomChange }: PricingSectionProps) => (
  <div className="tw-flex tw-flex-col tw-gap-2 tw-px-3 tw-py-3 tw-border-b tw-border-edge">
    <SectionHeading as="h4">{STRINGS.pane.pricing}</SectionHeading>

    <Checkbox
      label={STRINGS.pane.showUom}
      checked={showUom}
      onChange={onShowUomChange}
      size="sm"
    />
  </div>
);

export default PricingSection;
